module.exports = __webpack_public_path__ + "static/img/10-Modular-Homes.430e1ed0.jpg";